import { Directive, input } from '@angular/core'

import { Hero } from 'app/core/cms/type-unions'

import { DynamicInsert } from './dynamic-insert'
import { HERO_MAPPING } from './heroes/hero-mapping.const'

@Directive({ selector: 'ng-template[paiInsertDynamicHero]', standalone: true })
export class InsertDynamicHeroDirective extends DynamicInsert<typeof HERO_MAPPING> {
  readonly data = input.required<Hero>({ alias: 'paiInsertDynamicHero' })
  protected readonly blockMapping = HERO_MAPPING
}
